import React from 'react'
import PropTypes from 'prop-types'

const Phone = function({number, countryCode, ...rest}) {
  const parsed = countryCode + number

  const styles = {
    direction: "ltr",
    display: "inline-block",
    alignItems: "flex-start",
    justifyContent: "flex-end",
  }

  return (
    <a href={"tel:" + parsed} style={styles} {...rest}>
      <span>{countryCode}&nbsp;</span>
      <span>{number}</span>
    </a>
  )
}

Phone.propTypes = {
  number: PropTypes.string,
  countryCode: PropTypes.string,
}

export default Phone